import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

const sellModeAuthSchema = yup
  .object({
    businessAccessCode: yup.string().required("Access Code is required"),
  })
  .required();

const SellmodeAuthValidation = ({ businessAccessCode }) => {
  return useForm({
    resolver: yupResolver(sellModeAuthSchema),
    shouldFocusError: true,
    mode: "onBlur",
    defaultValues: {
      businessAccessCode,
    },
  });
};

export default SellmodeAuthValidation;
